/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Toast_Update_PnkInputs */

const vi_aml_toast_update_pnk = /** @type {(inputs: Aml_Toast_Update_PnkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã cập nhật phiếu nhập kho`)
};

/**

* @param {Aml_Toast_Update_PnkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_toast_update_pnk = /** @type {((inputs?: Aml_Toast_Update_PnkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Toast_Update_PnkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_toast_update_pnk(inputs)
});